export class EmptyScoringDefinitionsError extends Error {
  constructor() {
    super();
    this.name = 'EmptyScoringDefinitionsError';
    this.message = 'SCORE_SETTINGS.ERRORS.EMPTY_SCORING_DEFINITIONS';
  }
}

export class InvalidContributionError extends Error {
  constructor() {
    super();
    this.name = 'InvalidContributionError';
    this.message = 'SCORE_SETTINGS.ERRORS.INVALID_CONTRIBUTION';
  }
}

export class EmptyScoringRulesError extends Error {
  constructor() {
    super();
    this.name = 'EmptyScoringRulesError';
    this.message = 'SCORE_SETTINGS.ERRORS.EMPTY_SCORING_RULES';
  }
}

export class MissingFieldError extends Error {
  constructor() {
    super();
    this.name = 'MissingFieldError';
    this.message = 'SCORE_SETTINGS.ERRORS.INVALID_FIELD';
  }
}

export class MissingOperatorError extends Error {
  constructor() {
    super();
    this.name = 'MissingOperatorError';
    this.message = 'SCORE_SETTINGS.ERRORS.INVALID_OPERATOR';
  }
}

export class MissingValueError extends Error {
  constructor() {
    super();
    this.name = 'MissingValueError';
    this.message = 'SCORE_SETTINGS.ERRORS.INVALID_VALUE';
  }
}
